import { BaseWidgetContainer } from 'components/page/BaseLandingPage';
import { SpinnerArea } from 'components/spinner/SpinnerArea';
import styled from 'styled-components';
import { tokens } from 'styles/tokens';

export const Container = styled(BaseWidgetContainer)`
    display: flex;
    flex-direction: column;
    min-height: 0;
`;

export const Title = styled.h2`
    color: ${tokens.text.primary};
    font-size: 2.4rem;
    line-height: 1.25;
    font-weight: 500;
    margin: 0;
`;

export const CountText = styled.span`
    color: ${tokens.text.primary};
`;

export const PercentText = styled.span`
    color: ${tokens.text.secondary};
    margin-left: 0.4rem;
`;

export const StyledSpinnerArea = styled(SpinnerArea)`
    padding: 4rem 0;
`;
